export default from './BuyerRegistration';



// WEBPACK FOOTER //
// ./src/components/ReferralRealEstateAgent/components/BuyerRegistration/index.js